import { Button } from "@/components/ui/button";
import { Phone, Mail, Calendar } from "lucide-react";

const ContactCTASection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="contact-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto animate-fade-in">
          <h2 id="contact-title" className="text-3xl md:text-4xl font-bold mb-4">
            Ready for a Faster Website?
          </h2>
          <p className="text-muted-foreground text-lg mb-8">
            Let's discuss your project and show you what's possible.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button asChild size="lg" className="font-semibold">
              <a href="/meeting">
                <Calendar className="mr-2 w-4 h-4" />
                SCHEDULE A CALL
              </a>
            </Button>
            <Button asChild variant="outline" size="lg" className="font-semibold">
              <a href="tel:+13236384871">
                <Phone className="mr-2 w-4 h-4" />
                (323) 638-4871
              </a>
            </Button>
            <Button asChild variant="outline" size="lg" className="font-semibold">
              <a href="/contact">
                <Mail className="mr-2 w-4 h-4" />
                EMAIL US
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTASection;
